import React from "react";

import { formatMonto } from "../../utils";
import usePreciario from "../../hooks/usePreciario";

const MontosSugeridosEstimacion = ({
  anticipo,
  estimado,
  autorizado,
  sugerido,
  montoAnticipo,
}) => {

  const { porAmortizar, totalCuenta, totalAmortizado } = usePreciario();

  return (
    <div>
      <label className="bold">Montos Sugeridos</label>
      <table className="table small">
        <tbody>
          <tr>
            <td className="bg-light border">Anticipo ($)</td>
            <td className="border">
              ${formatMonto(montoAnticipo)} ({anticipo}%)
            </td>
          </tr>
          <tr>
            <td className="bg-light border">Pagos a Cuenta ($)</td>
            <td className="border">
              ${formatMonto(totalCuenta)}
            </td>
          </tr>
          <tr>
            <td className="bg-light border">Amortizado ($)</td>
            <td className="border">
              ${formatMonto(totalAmortizado)}
            </td>
          </tr>
          <tr>
            <td className="bg-light border">Por Amortizar ($)</td>
            <td className="border">${formatMonto(porAmortizar)}</td>
          </tr>
          <tr>
            <td className="bg-light border">Total Solicitado</td>
            <td className="border">${formatMonto(estimado)}</td>
          </tr>
          <tr>
            <td className="bg-light border">Total Autorizado</td>
            <td className="border">${formatMonto(autorizado)}</td>
          </tr>
          <tr>
            <td className="bg-light bold border">
              Sugerido ({100 - anticipo}%)
            </td>
            <td className="border bold">${formatMonto(sugerido)}</td>
          </tr>
          <tr>
            <td className="bg-light border">Amortización Sugerida</td>
            <td className="border">
              ${formatMonto(autorizado - sugerido)}
            </td>
          </tr>
          <tr>
            <td className="bg-light border">Anticipo Restante</td>
            <td className="border">
              ${formatMonto(porAmortizar - (autorizado - sugerido))}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default MontosSugeridosEstimacion;
